/** @jsxImportSource @emotion/react */
import type { ReactElement } from 'react';
import Avatar from '../Avatar';
import { themeColors } from 'bc-ods';
import { cx } from '@emotion/css';

interface PropTypes {
  account?: {
    name: string;
    firstName?: string | null;
    lastName?: string | null;
    avatarColor?: string | null;
  };
  className?: string;
  active?: boolean;
  isApi?: boolean;
}

const firstLetter = (value?: string | null) => (value || '').charAt(0).toUpperCase();

function AccountAvatar(props: PropTypes): ReactElement {
  const { account, className, ...rest } = props;

  const nameInitials = () => {
    if (!account) {
      return '';
    }

    return (
      `${firstLetter(account.firstName)}${firstLetter(account.lastName)}` ||
      firstLetter(account.name)
    );
  };

  const avatarContent = nameInitials();
  const color = account?.avatarColor ?? themeColors.border;

  return <Avatar content={avatarContent} className={cx(className)} color={color} {...rest} />;
}

export default AccountAvatar;
